{
  "iframeWaitingMessage": "Vielen Dank für Ihre Geduld. Nur noch ein kurzer Moment ...",
  "solutionIframe": "Hauptinhalt"
}
